function clonePendingCanvasEdgeAdd(edge) {
  return {
    ...edge,
  };
}

function resolveCanvasEdgeQueueReset(queueState, options) {
  const preserveQueuedMutations = options?.preserveQueuedMutations === true;

  if (!preserveQueuedMutations) {
    return {
      pendingEdgeAdds: [],
      pendingEdgeRemoves: [],
      deferredEdgeAdds: [],
    };
  }

  return {
    pendingEdgeAdds: Array.isArray(queueState?.pendingEdgeAdds)
      ? queueState.pendingEdgeAdds.map(clonePendingCanvasEdgeAdd)
      : [],
    pendingEdgeRemoves: Array.isArray(queueState?.pendingEdgeRemoves)
      ? [...queueState.pendingEdgeRemoves]
      : [],
    deferredEdgeAdds: queueState?.deferredEdgeAdds instanceof Map
      ? Array.from(queueState.deferredEdgeAdds.entries()).map(([edgeId, edge]) => [edgeId, clonePendingCanvasEdgeAdd(edge)])
      : [],
  };
}

function isPersistedCanvasNode(node, extraPersistedNodeIds) {
  return Boolean(
    node
    && extraPersistedNodeIds.has(node.id),
  );
}

function buildCanvasEdgeFullSyncPlan(nodes, edges, extraPersistedNodeIds) {
  const nodeById = new Map(nodes.map((node) => [node.id, node]));
  const extraPersistedIdSet = new Set(extraPersistedNodeIds || []);
  const persistedEdges = [];
  const deferredAdds = [];
  const deferredEdgeIds = [];

  edges.forEach((edge) => {
    const sourceNode = nodeById.get(edge.source);
    const targetNode = nodeById.get(edge.target);
    if (!sourceNode || !targetNode) {
      return;
    }

    const payloadItem = {
      id: edge.id,
      source_node_id: edge.source,
      target_node_id: edge.target,
      source_handle: edge.sourceHandle || null,
      target_handle: edge.targetHandle || null,
      relation_type: edge.relationType || null,
      relation_label: edge.relationLabel || null,
    };

    if (isPersistedCanvasNode(sourceNode, extraPersistedIdSet) && isPersistedCanvasNode(targetNode, extraPersistedIdSet)) {
      persistedEdges.push(payloadItem);
      return;
    }

    deferredAdds.push(payloadItem);
    deferredEdgeIds.push(edge.id);
  });

  return {
    edges: persistedEdges,
    deferredAdds,
    deferredEdgeIds,
  };
}

function buildMissingCanvasEdgeNodeRecoveryPlan(edges, missingNodeIds) {
  const missingNodeIdSet = new Set(
    Array.isArray(missingNodeIds)
      ? missingNodeIds.filter((nodeId) => typeof nodeId === 'string' && nodeId.length > 0)
      : [],
  );

  const deferredAdds = [];
  const deferredEdgeIds = [];

  if (missingNodeIdSet.size === 0 || !Array.isArray(edges)) {
    return {
      missingNodeIds: Array.from(missingNodeIdSet),
      deferredAdds,
      deferredEdgeIds,
    };
  }

  edges.forEach((edge) => {
    if (!edge || typeof edge.id !== 'string') {
      return;
    }

    if (!missingNodeIdSet.has(edge.source_node_id) && !missingNodeIdSet.has(edge.target_node_id)) {
      return;
    }

    deferredAdds.push(clonePendingCanvasEdgeAdd(edge));
    deferredEdgeIds.push(edge.id);
  });

  return {
    missingNodeIds: Array.from(missingNodeIdSet),
    deferredAdds,
    deferredEdgeIds,
  };
}

module.exports = {
  buildCanvasEdgeFullSyncPlan,
  buildMissingCanvasEdgeNodeRecoveryPlan,
  resolveCanvasEdgeQueueReset,
};
